import { IApp03Template, IEntityChildren, IEntityDescription1 } from '../types';
import { AppGlobals } from '../AppGlobals';
import { EntityService } from './EntityService';
import { App03Frameworks } from '../types/App03Workflow';

export class App03TemplateService extends EntityService<IApp03Template> {

    protected childrenEntities = [
        'App03WorkItemTypes',
        'App03Workflows',
    ];


    constructor() {
        super(`/App03Templates`);
    }

    public readAllForList(frameworkID?: App03Frameworks): Promise<IApp03Template[]> {
        return this.readAll(
            `?$select=ID,Title,Description`
            + `&$orderby=ID`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID} and FrameworkID eq ${frameworkID}`
        );
    }

    public readAllForLookup(): Promise<IApp03Template[]> {
        return this.readAll(
            `?$select=ID,Title,FrameworkID`
            + `&$orderby=ID`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
        );
    }

    public async readTitleForTemplate(entityPlural: string, entitySingular: string, templateID: number): Promise<IEntityDescription1> {
        const entityDescription1: IEntityDescription1 = {
            Description1ForList: '',
            Description1ForForm: '',
            DescriptionLine1: '',
            DescriptionLine2: '',
        };
        const res = await this.readAll(`?$filter=ID eq ${templateID}&$select=Title`);
        if (res.length > 0) {
            entityDescription1.DescriptionLine1 = `${entityPlural} for template`;
            entityDescription1.DescriptionLine2 = res[0].Title;
            entityDescription1.Description1ForList = `${entityPlural} for template <span style='font-style: italic'>${res[0].Title}</span>`;
            entityDescription1.Description1ForForm = `${entitySingular} for template <span style='font-style: italic'>${res[0].Title}</span>`;
        }

        return entityDescription1;
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const entityUrl = `${this.entityUrl}(${id})`;
        const app03WorkItemTypes = (await this.axiosGet(`${entityUrl}/App03WorkItemTypes?$select=ID&$top=10`)).data.value;
        const app03Workflows = (await this.axiosGet(`${entityUrl}/App03Workflows?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Work Item Types', CanBeAdopted: false, ChildIDs: (await app03WorkItemTypes).map((m: { ID: any }) => m.ID) },
            { ChildType: 'Workstreams', CanBeAdopted: false, ChildIDs: (await app03Workflows).map((m: { ID: any }) => m.ID) },
        ];
    }
}